export default {
    state: {
        user: { isLoaded: false },
        domainList: { list: [], isLoaded: false},

        isMockPublisherChat: false,
    },
    actions: {
        async getUser({ commit }) {
            const result = await this.makeRequest({
                reqFunc: this.apiService.getUser
            });

            if (result && result.data) {
                commit("SET_USER", result.data.data);
                return result.data.data;
            }

            return false;
        },
        async getPublisherDomainList({ commit }) {
            const result = await this.makeRequest({
                reqFunc: this.apiService.getDomainList,
                payload: null,
            });

            if (result && result.data) {
                commit("SET_DOMAIN_LIST", result.data.data.list);
            }
        },
        setIsMockPublisherChat({ commit }, data) {
            commit("SET_IS_MOCK_PUBLISHER_CHAT", data);
        }
    },
    mutations: {
        SET_USER(state, data) {
            state.user = {
                ...data,
                isLoaded: true,
            }
        },
        SET_DOMAIN_LIST(state, data) {
            state.domainList = {
                list: data,
                isLoaded: true,
            }
        },  
        SET_IS_MOCK_PUBLISHER_CHAT(state, data) {
            state.isMockPublisherChat = data;
        },      
    },
    getters: {
        user: state => state.user,
        publisherDomainList: state => state.domainList,
        isMockPublisherChat: state => state.isMockPublisherChat,
    }
}